import { Button } from "@wordpress/components";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { settings } from "settings";
import { getFrequencyText } from "utils";

const WineClubCard = ({ wineClub }) => {
	const frequency = getFrequencyText(wineClub.frequency);

	const handleJoin = () => {
		location.href = `${settings.urls.subscription}?clubId=${wineClub.id}`;
	};

	return (
		<Card className="relative rounded-16">
			<div className="pt-48 pb-24 text-center">
				<Typography
					variant="subtitle1"
					color="inherit"
					className="text-20 font-semibold"
				>
					{wineClub.name}
				</Typography>
			</div>

			<CardContent className="text-center p-0">
				<div className="flex flex-col">
					<div className="flex justify-center mb-8">
						<Typography
							variant="h5"
							color="textSecondary"
							className="font-semibold"
						>
							$
						</Typography>
						<Typography className="text-56 mx-4 tracking-tight font-semibold leading-none">
							{wineClub.price}
						</Typography>
					</div>
				</div>

				<div className="flex flex-col p-32">
					<Typography variant="subtitle1" className="mb-8">
						<span className="font-semibold mx-4">{wineClub.bottles}</span>
						<span>bottles</span>
					</Typography>

					<Typography variant="subtitle1" className="mb-8">
						{frequency}
					</Typography>
				</div>
			</CardContent>

			<div className="flex justify-center pb-32">
				<Button variant="outlined" className="w-128" onClick={handleJoin}>
					Join Now
				</Button>
			</div>
		</Card>
	);
};

export default WineClubCard;
